import React, { useState } from 'react';
import { FilterState } from '../../types';

export interface FilterPanelProps {
  filters: FilterState;
  onFilterChange: (filters: FilterState) => void;
}

/**
 * Painel dropdown de filtros do board (probation, faltas, aniversário).
 * @param props - Estado de filtros e callback de atualização
 */
export const FilterPanel: React.FC<FilterPanelProps> = ({ filters, onFilterChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const activeFiltersCount = Object.values(filters).filter(Boolean).length;

  const toggleFilter = (key: keyof FilterState) => {
    onFilterChange({ ...filters, [key]: !filters[key] });
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`flex h-7 items-center justify-center rounded-lg border px-3 text-[11px] font-semibold transition-all shadow-sm active:scale-95 ${activeFiltersCount > 0 ? 'bg-secondary-accent/5 border-secondary-accent text-secondary-accent' : 'bg-white border-slate-200 text-slate-600 hover:border-slate-300'}`}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <span className="material-symbols-outlined mr-1.5 !text-[14px]">filter_list</span>
        Filtros
        {activeFiltersCount > 0 && (
          <span className="ml-1.5 size-3 rounded-full bg-secondary-accent text-white flex items-center justify-center text-[8px] font-black">
            {activeFiltersCount}
          </span>
        )}
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} aria-hidden="true" />
          <div className="absolute right-0 top-full mt-1.5 w-48 bg-white rounded-xl shadow-xl border border-slate-100 p-1.5 z-50 animate-in fade-in zoom-in-95 duration-200 origin-top-right">
            <div className="px-2.5 py-1.5 mb-1 border-b border-slate-50 flex justify-between items-center">
              <span className="text-[9px] font-bold text-slate-400 uppercase tracking-widest">Opções de Filtro</span>
              {activeFiltersCount > 0 && (
                <button
                  type="button"
                  onClick={() =>
                    onFilterChange({ probation45: false, probation90: false, hasAbsences: false, isBirthday: false })
                  }
                  className="text-[8px] font-bold text-secondary-accent hover:underline"
                >
                  Limpar
                </button>
              )}
            </div>
            <div className="space-y-0.5">
              <button
                type="button"
                onClick={() => toggleFilter('probation45')}
                className={`flex items-center w-full gap-2 px-2.5 py-1.5 rounded-lg text-[11px] font-medium transition-colors ${filters.probation45 ? 'bg-orange-50 text-orange-600' : 'text-slate-600 hover:bg-slate-50'}`}
              >
                <span className="material-symbols-outlined !text-[14px]">
                  {filters.probation45 ? 'check_box' : 'check_box_outline_blank'}
                </span>
                45 Dias
              </button>
              <button
                type="button"
                onClick={() => toggleFilter('probation90')}
                className={`flex items-center w-full gap-2 px-2.5 py-1.5 rounded-lg text-[11px] font-medium transition-colors ${filters.probation90 ? 'bg-blue-50 text-secondary-accent' : 'text-slate-600 hover:bg-slate-50'}`}
              >
                <span className="material-symbols-outlined !text-[14px]">
                  {filters.probation90 ? 'check_box' : 'check_box_outline_blank'}
                </span>
                90 Dias
              </button>
              <button
                type="button"
                onClick={() => toggleFilter('hasAbsences')}
                className={`flex items-center w-full gap-2 px-2.5 py-1.5 rounded-lg text-[11px] font-medium transition-colors ${filters.hasAbsences ? 'bg-red-50 text-status-red' : 'text-slate-600 hover:bg-slate-50'}`}
              >
                <span className="material-symbols-outlined !text-[14px]">
                  {filters.hasAbsences ? 'check_box' : 'check_box_outline_blank'}
                </span>
                Com Faltas (mês)
              </button>
              <button
                type="button"
                onClick={() => toggleFilter('isBirthday')}
                className={`flex items-center w-full gap-2 px-2.5 py-1.5 rounded-lg text-[11px] font-medium transition-colors ${filters.isBirthday ? 'bg-pink-50 text-pink-500' : 'text-slate-600 hover:bg-slate-50'}`}
              >
                <span className="material-symbols-outlined !text-[14px] text-pink-400">cake</span>
                Aniversariantes
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
